export default {
  methods: {
    changeNav (item) {
      const { path } = item
      const currPath = this.$route.path
      if (path === currPath) {
        return
      }
      this.$router.push(path)
    }
  }
}
